import {initializeApp} from 'firebase/app';
import {getStorage} from 'firebase/storage';
import {getMessaging} from "firebase/messaging"
import {browserLocalPersistence, browserPopupRedirectResolver, initializeAuth} from "@firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyDkL79uXiZT6y0JGDvIdBtp5ni0f4S0fLU",
    authDomain: "score-vision-6989f.firebaseapp.com",
    projectId: "score-vision-6989f",
    storageBucket: "score-vision-6989f.firebasestorage.app",
    messagingSenderId: "723394412931",
    appId: "1:723394412931:web:c97346234ff0c0547636b6",
    measurementId: "G-9HP4D4K0XT",
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
/**
 * `initializeAuth` only wires what it is given, so the popup resolver has to be declared here:
 * without it the Google sign in popup fails with an argument error instead of opening.
 */
export const auth = initializeAuth(app, {
    persistence: browserLocalPersistence,
    popupRedirectResolver: browserPopupRedirectResolver
})